document.addEventListener("DOMContentLoaded", function(){
crearGaleria()
});

function crearGaleria(){

const galeria = document.querySelector(".galeria-imagenes");

for( let i = 1 ; i <= 12; i++){

const imagen = document.createElement("IMG")

//mostrarImagen
imagen.onclick = mostrarImagen;

imagen.src = `build/img/thumb/${i}.webp`;
imagen.dataset.imagenId = i;


const lista = document.createElement("LI")
lista.appendChild(imagen);

galeria.appendChild(lista)

    }
}

function mostrarImagen(e){

    const galeria = document.querySelector(".galeria-imagenes");
    const id = parseInt(e.target.dataset.imagenId);


    const imagen = document.createElement("IMG");
    imagen.src = `build/img/grande/${id}.jpg`;
    const overlay = document.createElement("DIV");
    overlay.appendChild(imagen);
    overlay.classList.add("overlay")

    // Boton cerrar imagen

    const cerrarImagen = document.createElement("P");
    cerrarImagen.textContent = "X"
    cerrarImagen.classList.add("btn-cerrar");
    overlay.appendChild(cerrarImagen);

     // cuando se presiona se cierra la imagen

     cerrarImagen.onclick = function(){

        overlay.remove();
        body.classList.add("nofijar-body")

     }

    // Mostrar en HTML
    const body = document.querySelector("body");
    body.appendChild(overlay)

     body.classList.add("fijar-body")


    

}




